import { t } from 'ttag';
import { gettextSymptoms } from '@/shared/lib';

/**
 * Renders a study's symptom value for display. Maps the sentinel None onto a localized Not specified label, otherwise returns the translated symptom or an empty string.
 *
 * @param symptoms - Raw symptom value recorded on the study.
 * @returns The display text for the symptom.
 */
const symptomsFormatter = (symptoms: any) =>
  symptoms === 'None' ? t`Not specified` : gettextSymptoms(symptoms) || '';

export { symptomsFormatter };
